import { ComponentType } from 'react';

import BtcIcon from '#/assets/BtcIcon';
import EthIcon from '#/assets/EthIcon';
import SolIcon from '#/assets/SolIcon';
import UsdcIcon from '#/assets/UsdcIcon';

interface IconProps {
  readonly size: number;
}

const ASSET_ICONS: Record<string, ComponentType<IconProps>> = {
  'BTC-USD-PERP': BtcIcon,
  'ETH-USD-PERP': EthIcon,
  'SOL-USD-PERP': SolIcon,
  USDC: UsdcIcon,
};

interface Props {
  readonly asset: string;
  readonly size: number;
}

export default function AssetIcon(props: Props) {
  const { asset, size } = props;
  const Icon = ASSET_ICONS[asset];

  if (Icon == null) return <span />; // WIP return some 'default' icon

  return <Icon size={size} />;
}
